




















































































import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onMounted
} from "@vue/composition-api";
import dayjs from "dayjs";
import { ORDER_TYPE } from "@/api/types";
import Layout from "@/components/Atoms/Layout/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import FileSearchField from "./Organisms/FileSearchField/index.vue";
import Pagination from "@/components/Atoms/Pagination/index.vue";
import Table from "@/components/Molecules/Table/index.vue";
import TableHead from "@/components/Molecules/Table/Head/index.vue";
import TableHeadRow from "@/components/Molecules/Table/Head/Row/index.vue";
import TableHeadHeader from "@/components/Molecules/Table/Head/Header/index.vue";
import TableBody from "@/components/Molecules/Table/Body/index.vue";
import TableBodyRow from "@/components/Molecules/Table/Body/Row/index.vue";
import TableBodyData from "@/components/Molecules/Table/Body/Data/index.vue";
import { useStore } from "@/store";

const LIMIT = 10;

interface Data {
  searchText: string;
  order: ORDER_TYPE;
  offset: number;
  limit: number;
}

export default defineComponent({
  components: {
    Layout,
    Heading,
    Caption,
    FileSearchField,
    Pagination,
    Table,
    TableBody,
    TableBodyRow,
    TableBodyData,
    TableHead,
    TableHeadHeader,
    TableHeadRow
  },
  setup(_, { root }) {
    // スカウトエージェントメニューがアクティブ状態かどうかを判定する
    const isScoutAgentMenuActive = () => {
      const store = useStore();
      return store.getters["domains/user/isScoutAgentMenuActive"];
    };

    const files = computed(() => {
      return root.$store.state.domains.files.files;
    });
    const fileTotal = computed(() => {
      return root.$store.state.domains.files.file_total;
    });
    const pageTotal = computed(() => {
      return Math.ceil(fileTotal.value / LIMIT);
    });
    const downloadedFile = computed(() => {
      return root.$store.state.domains.files.file;
    });

    const state = reactive<Data>({
      searchText: "",
      order: "DESC",
      offset: 0,
      limit: LIMIT
    });

    const getFiles = () => {
      root.$store.dispatch("domains/files/getFiles", {
        file_name: state.searchText,
        agent_scout: isScoutAgentMenuActive(),
        order: state.order,
        offset: state.offset * 10,
        limit: state.limit
      });
    };
    const getDownloadFile = (fileId: number, fileName: string) => {
      root.$store.dispatch("domains/files/getDownloadFile", {
        file_id: fileId,
        file_name: fileName
      });
      getFiles();
    };

    onMounted(() => {
      getFiles();
    });

    const uploadedAt = (at: string) => dayjs(at).format("YYYY/MM/DD");

    const convertedKB = (size: number) =>
      (Math.ceil(size / 100) / 10).toLocaleString();

    const onChangePage = (page: number) => {
      state.offset = page - 1;
      getFiles();
    };

    const handleSearch = (value: string) => {
      state.searchText = value;
      getFiles();
    };

    const handleChangeOrder = (order: ORDER_TYPE) => {
      state.order = order;
      getFiles();
    };

    const handleClickDownload = (fileId: number, fileName: string) => {
      getDownloadFile(fileId, fileName);
      getFiles();
    };

    return {
      ...toRefs(state),
      files,
      fileTotal,
      pageTotal,
      downloadedFile,
      onChangePage,
      uploadedAt,
      convertedKB,
      handleSearch,
      handleChangeOrder,
      handleClickDownload
    };
  }
});
